import React from 'react';

const SupportUs = () => <h1 className="text-center mt-5">Contact Page</h1>;
export default SupportUs;

// Similar structure for other pages (AboutUs.js, FAQ.js, SupportUs.js, Products.js)
